/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { currentUser, isAuthenticated } from '@app/auth/store/auth.selectors';
import { getAvailableLocation, getCurrentLocation } from '@app/tours/store/tours.selectors';
import { UsersService } from '@app/user/services/users.service';
import * as UsersActions from '@app/user/store/users.actions';
import * as AuthActions from '@auth/store/auth.actions';
import { State } from '@core/store';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { Location, User } from '@shared/models';
import * as TourActions from '@tours/store/tours.actions';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  authenticatedUser$: Observable<User|null>;
  currentUser$: Observable<User>;
  isUserAuthenticated$: Observable<boolean>;

  locations: Location[];
  currentLocation$: Observable<Location>;
  availableLocations$: Observable<Location[]>;
  currentUserId: string;
  color: string;
  headerImage: string;
  headerAltText: string;

  constructor(private store: Store<State>, private userService: UsersService) {
    this.color = environment.headerColor;
    this.headerImage = environment.headerImage;
    this.headerAltText = environment.headerAltText;
  }

  ngOnInit(): void {
    this.authenticatedUser$ = this.store.select(currentUser);
    this.isUserAuthenticated$ = this.store.select(isAuthenticated);
    this.currentLocation$ = this.store.select(getCurrentLocation);
    this.availableLocations$ = this.store.select(getAvailableLocation);
    this.availableLocations$.subscribe(locations => this.locations = locations);
    this.authenticatedUser$.pipe(
      tap(user => {
        this.currentUserId = user['@id'];
        this.currentUser$ = this.userService.getUser(this.currentUserId);
      }
    ));
  }

  onEditAccount(id: string): void {
    this.store.dispatch(new UsersActions.EditUserProfile(id));
  }

  onLogout(): void {
    this.store.dispatch(new AuthActions.Logout());
  }

  onLocationChange(event): void {
    const targetLocations = this.locations.filter(location => location['@id'] === event.value);
    if (targetLocations.length === 0 || targetLocations.length > 1) {
      return;
    }

    this.store.dispatch(new TourActions.SetCurrentLocation(targetLocations[0]));
  }
}
